import React from 'react';
import IndexPage from './home/IndexPage';
import EmailConfirmedPage from './home/EmailConfirmedPage';
import { useLocation } from 'react-router-dom';

const Index: React.FC = () => {
  const location = useLocation();
  
  // Check for token in URL, which indicates email confirmation
  const searchParams = new URLSearchParams(location.search);
  const hasToken = searchParams.has('token');
  
  // If token is present, show the email confirmation page
  if (hasToken) {
    return <EmailConfirmedPage />;
  }
  
  // Otherwise, show the regular home page
  return <IndexPage />;
};

export default Index;
